import React, { useState, useEffect } from 'react'

import { array } from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import isDOMAvailable from 'utils/isDOMAvailable'

import Button from 'components/atoms/Button'
import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'
import ThumbnailSlider from 'components/molecules/ThumbnailSlider'
import CampusPerfectCard from 'components/organisms/CampusPerfectCard'
import SchoolsModal from 'components/paperplane/SchoolsModal'

import config from 'config'

const { assets_url: assetsUrl } = config

const SchoolList = ({ schools, option }) => (
  schools.map((school, idx) => (
    <div key={school.id} className="m-y-sm col-md-4 col-sm-6 col-xs-12">
      <CampusPerfectCard
        dataTestId={`rec-campus-card-${idx}`}
        description={school.description}
        logo={school.logo}
        thumbnail={school.img}
        href={`/directory/${school.slug}`}
        kind="schools"
        title={school.name}
        major={school.major}
        capacity={school.capacity}
        interest={school.previous_year_registrants}
        competitiveLevel={Math.round(school.competitive_rate * 100)}
        flag={idx === 0 ? `Pilihan ${option}` : ''}
        withFooter
        shortImage
        withFlag={school.competitive_rate}
        category={school.competitive_rate ? 'Negeri' : 'Swasta'}
      />
    </div>
  ))
)

export { SchoolList }

const PaperplaneRecommendation = ({ recomendation1, recomendation2 }) => {
  const [showMore1, setShowMore1] = useState(false)
  const [showMore2, setShowMore2] = useState(false)
  const [showModal1, setShowModal1] = useState(false)
  const [showModal2, setShowModal2] = useState(false)
  const [option, setOption] = useState(null)
  const [countSchool1, setCountSchool1] = useState(3)
  const [schools1, setSchool1] = useState(recomendation1.slice(0, 3))
  const [countSchool2, setCountSchool2] = useState(3)
  const [schools2, setSchool2] = useState(recomendation2.slice(0, 3))
  const schools1Length = recomendation1.length
  const schools2Length = recomendation2.length

  useEffect(() => {
    if (showMore1) {
      const addSchool = schools1Length - countSchool1 < 3 ? (countSchool1 + (schools1Length % 3)) : countSchool1 + 3
      const newSchools = recomendation1.slice(countSchool1, addSchool)
      setSchool1(schools1.concat(newSchools))
      setCountSchool1(addSchool)
      setShowMore1(false)
    }
    if (showMore2) {
      const addSchool = schools2Length - countSchool2 < 3 ? (countSchool2 + (schools2Length % 3)) : countSchool2 + 3
      const newSchools = recomendation2.slice(countSchool2, addSchool)
      setSchool2(schools2.concat(newSchools))
      setCountSchool2(addSchool)
      setShowMore2(false)
    }
  }, [showMore1, showMore2])
  // const [schoolChoosen, chooseSchool] = useState(null)
  return (
    <div id="paperplane-recommendation" className="paperplane-recommenation">
      <SectionContainer paddingBottom={80}>
        <Container next>
          <Typography component="h2" variant="title" className="text-variant-title-sm m-b-sm">
            Kampus Rekomendasi Kami
          </Typography>
          <Typography component="p" variant="body" className="paperplane-recommendation__subtitle">
            Berikut adalah daftar kampus yang direkomendasikan sesuai dengan jurusan yang kamu pilih.
          </Typography>
          <div className="paperplane-recommendation__school-list">
            <div className="paperplane-recommendation__show-more-mobile">
              <div className="paperplane-recommendation__flag">
                <Typography component="span" variant="caption">Pilihan 1</Typography>
              </div>
              <Button
                variant="link"
                className="paperplane-recommendation__btn-mobile"
                onClick={() => {
                  setShowModal1(true)
                  setOption(1)
                  // chooseSchool(schools)
                }}
              >
                Lihat Semua
              </Button>
            </div>
            { (isDOMAvailable && window.outerWidth < 768) ?
              <ThumbnailSlider>
                {
                  schools1.slice(0, 3).map((school, idx) => (
                    <div key={school.id} className="m-y-sm col-md-4 col-sm-6 col-xs-12">
                      <CampusPerfectCard
                        dataTestId={`rec-campus-card-${idx}`}
                        description={school.description}
                        logo={school.logo}
                        thumbnail={school.img}
                        href={`/directory/${school.slug}`}
                        kind="schools"
                        title={school.name}
                        major={school.major}
                        capacity={school.capacity}
                        interest={school.previous_year_registrants}
                        competitiveLevel={Math.round(school.competitive_rate * 100)}
                        flag={idx === 0 ? `Pilihan ${option}` : ''}
                        withFooter
                        shortImage
                        withFlag={school.competitive_rate}
                        category={school.competitive_rate ? 'Negeri' : 'Swasta'}
                      />
                    </div>
                  ))
                }
              </ThumbnailSlider> :
              <SchoolList schools={schools1} option={1} />
            }
          </div>
          {
            schools1Length > 3 && (schools1Length !== countSchool1) &&
            <div className="paperplane-recommendation__show-more">
              <Button variant="solid" className="paperplane-recommendation__btn" onClick={() => setShowMore1(true)}>
                Muat Lebih Banyak
              </Button>
            </div>
          }
          <div className="paperplane-recommendation__school-list">
            <div className="paperplane-recommendation__show-more-mobile">
              <div className="paperplane-recommendation__flag">
                <Typography component="span" variant="caption">Pilihan 2</Typography>
              </div>
              <Button
                variant="link"
                className="paperplane-recommendation__btn-mobile"
                onClick={() => {
                  setShowModal2(true)
                  setOption(2)
                  // chooseSchool(schools)
                }}
              >
                Lihat Semua
              </Button>
            </div>
            { (isDOMAvailable && window.outerWidth < 768) ?
              <ThumbnailSlider>
                {
                  schools2.slice(0, 3).map((school, idx) => (
                    <div key={school.id} className="m-y-sm col-md-4 col-sm-6 col-xs-12">
                      <CampusPerfectCard
                        dataTestId={`rec-campus-card-${idx}`}
                        description={school.description}
                        logo={school.logo}
                        thumbnail={school.img}
                        href={`/directory/${school.slug}`}
                        kind="schools"
                        title={school.name}
                        major={school.major}
                        capacity={school.capacity}
                        interest={school.previous_year_registrants}
                        competitiveLevel={Math.round(school.competitive_rate * 100)}
                        flag={idx === 0 ? `Pilihan ${option}` : ''}
                        withFooter
                        shortImage
                        withFlag={school.competitive_rate}
                        category={school.competitive_rate ? 'Negeri' : 'Swasta'}
                      />
                    </div>
                  ))
                }
              </ThumbnailSlider> :
              <SchoolList schools={schools2} option={2} />
            }
          </div>
          {
            schools2Length > 3 && (schools2Length !== countSchool2) &&
            <div className="paperplane-recommendation__show-more">
              <Button variant="solid" className="paperplane-recommendation__btn" onClick={() => setShowMore2(true)}>
                Muat Lebih Banyak
              </Button>
            </div>
          }
        </Container>
      </SectionContainer>
      <SchoolsModal
        isOpen={showModal1}
        onModalClose={() => setShowModal1(false)}
        schools={recomendation1}
        index={option}
      />
      <SchoolsModal
        isOpen={showModal2}
        onModalClose={() => setShowModal2(false)}
        schools={recomendation2}
        index={option}
      />
      <style jsx>
        {`
          .paperplane-recommendation {
            &__show-more {
              text-align: center;
            }
            &__more-schools {
              padding-bottom: 24px;
            }
            :global(&__btn) {
              color: #1a344f;
              font-weight: bold;
            }
            @media screen and (min-width: 768px) {
              &__show-more-mobile, &__flag, :global(&__btn-mobile) {
                display: none;
              }
              &__school-list {
                padding: 24px 0;
                overflow: auto;
                display: flex;
                flex-wrap: wrap;
              }
            }

            @media screen and (max-width: 767px) {
              :global(&__subtitle) {
                line-height: 1.5 !important;
                font-size: 14px !important;
              }
              &__show-more, :global(&__btn) {
                display: none;
              }
              &__show-more-mobile {
                position: relative;
                text-align: right;
                margin-top: 24px;
                border-radius: 10px;
                box-shadow: 0 2px 12px 0 rgba(26, 52, 79, 0.1);
                background-color: #fff;
              }
              &__flag {
                background-image: url('${assetsUrl}/assets/img/paperplane/result/flag.svg');
                background-size: contain;
                background-repeat: no-repeat;
                position: absolute;
                left: -1%;
                top: 15%;
                padding: 2px 18px 10px 10px;
                :global(span) {
                  color: #fff;
                  font-weight: bold;
                }
              }
              :global(&__btn-mobile) {
                font-weight: bold;
                padding: 16px;
              }
              &__school-list {
                :global(.ThumbnailSlider) {
                  overflow: unset;
                  margin: 16px 0 0 0;
                  :global(.container) {
                    padding: 0;
                  }
                }
                :global(.slick-slider) {
                  overflow: hidden;
                  padding-bottom: 0;
                }
                :global(.slick-slide) {
                  height: inherit;
                }
                :global(.slick-slide > div) {
                  height: 100%;
                }
              }
            }
          }
        `}
      </style>
    </div>
  )
}

PaperplaneRecommendation.propTypes = {
  recomendation1: array,
  recomendation2: array,
}

PaperplaneRecommendation.defaultProps = {
  recomendation1: [],
  recomendation2: [],
}

export { PaperplaneRecommendation }
export default branch({
}, PaperplaneRecommendation)
